import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { getBreakpointFromManor } from 'ctm-components';

import { ErrorTitle } from './common/error_title';
import { ErrorContent } from './common/error_content';
import { Separator } from '../products/products/common/separator';
import { StartNewQuoteButton } from './common/start_new_quote_button';

import { sergeiShockedImgPath, sergeiShockedBackgroundImgPath } from './common/preload_image';
import { SergeiShocked } from './common/sergei_shocked';

const useStyles = createUseStyles((theme) => ({
    applicationErrorInfoContainer: {
        display: 'flex',
        extend: ({ breakpoint }) => {
            switch (breakpoint) {
                case 'lg': return { height: '29.3rem', width: '94.2rem' };
                case 'md': return { height: '24.5rem', width: '96rem' };
                default: return { height: '26.9rem', width: '68.8rem' };
            }
        }
    },
    leftSection: {
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        extend: ({ breakpoint }) => {
            switch (breakpoint) {
                case 'lg': return { width: '35.7rem' };
                case 'md': return { width: '29.9rem' };
                default: return { width: '26.8rem' };
            }
        }
    },
    rightSection: {
        flex: 1,
        paddingLeft: '3.3rem',
        paddingRight: '3.2rem',
        extend: ({ breakpoint }) => {
            switch (breakpoint) {
                case 'lg': return { paddingTop: '4.8rem' };
                case 'md': return { paddingTop: '1.8rem' };
                default: return { paddingTop: '2.7rem' };
            }
        }
    },
    picture: {
        position: 'absolute',
        objectFit: 'cover',
        objectPosition: 'top',
        width: '28rem',
        zIndex: '1',
        extend: ({ breakpoint }) => {
            switch (breakpoint) {
                case 'lg': return { left: '6.6rem', top: '0.6rem' };
                case 'md': return { left: '4.4rem', top: '0.2rem' };
                default: return { left: '1.7rem', top: '0.6rem' };
            }
        }
    },
    pictureBackground: {
        width: '100%'
    },
    errorContent: {
        paddingTop: theme.spacing[16],
        paddingRight: theme.spacing[16]
    },
    separatorBox: {
        marginTop: theme.spacing[24],
        marginBottom: theme.spacing[24]
    }
}));

const ApplicationErrorInfo = () => {
    const breakpoint = getBreakpointFromManor();
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme, breakpoint });

    return (
        <div className={classes.applicationErrorInfoContainer}>
            <div className={classes.leftSection}>
                <SergeiShocked className={classes.picture} imgSrc={sergeiShockedImgPath} />
                <SergeiShocked className={classes.pictureBackground} imgSrc={sergeiShockedBackgroundImgPath} />
            </div>
            <div className={classes.rightSection}>
                <ErrorTitle />
                <ErrorContent className={classes.errorContent} />
                <Separator type="horizontal" className={classes.separatorBox} />
                <StartNewQuoteButton />
            </div>
        </div>
    );
};

export { ApplicationErrorInfo };
